var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHeader1)?_c('div',{class:{
      'text-uppercase': _vm.isUppercaseActive,
      'asc-header--no-margins': _vm.isNoMargins,
      'asc-header--h1': true,
      'asc-header--active': _vm.isActive,
    },style:({ color: _vm.color === '' ? 'inherit' : _vm.color })},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),(_vm.isHeader2)?_c('div',{class:{
      'text-uppercase': _vm.isUppercaseActive,
      'asc-header--no-margins': _vm.isNoMargins,
      'asc-header--h2': true,
      'asc-header--active': _vm.isActive,
    },style:({ color: _vm.color === '' ? 'inherit' : _vm.color })},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),(_vm.isHeader3)?_c('div',{class:{
      'text-uppercase': _vm.isUppercaseActive,
      'asc-header--no-margins': _vm.isNoMargins,
      'asc-header--h3': true,
      'asc-header--active': _vm.isActive,
    },style:({ color: _vm.color === '' ? 'inherit' : _vm.color })},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),(_vm.isHeader4)?_c('div',{class:{
      'text-uppercase': _vm.isUppercaseActive,
      'asc-header--no-margins': _vm.isNoMargins,
      'asc-header--h4': true,
      'asc-header--active': _vm.isActive,
    },style:({ color: _vm.color === '' ? 'inherit' : _vm.color })},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }